import { useState, useMemo } from "react";
import useStyles from "./useStyles";
// eslint-disable-next-line
import jwt_decode from "jwt-decode";
import { useDispatch, useSelector } from "react-redux";
import {
  createSubsDelegationVE,
  getAllSubsDelegationVE,
} from "../../../redux/actions/eventanilla";
import { useNavigate } from "react-router-dom";
import cuitValidator from "../../../utils/CuitValidator";
import { getInfoARCA } from "../../../app/services/AFIP-api/getInfoARCA";

export default function CreateClient({ open, onClose, onSubmit }) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const user = useSelector((state) => state.user);
  const decoded = useMemo(() => (user?.eAuthToken ? jwt_decode(user.eAuthToken) : {}), [user?.eAuthToken]);

  const initialFormState = {
    customerSuborganizationCuit: "",
    customerSuborganizationName: "",
    delegationAcceptationUser: decoded?.idpData?.email || "",
    accessDelegationDateTime: new Date().toISOString().split("T")[0],
    delegationNotes: "",
  };

  const [formData, setFormData] = useState(initialFormState);
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [textInputCustomerCUIT, setTextInputCustomerCUIT] = useState("Cargando...");

  const validateCuitFull = async (cuit) => {
    if (!cuit) return;

    setLoading(true);
    const newErrors = { ...errors };
    delete newErrors.cuitInvalido;
    delete newErrors.isExistsCUIT;
    delete newErrors.isNotValidAFIP;

    if (cuit.length !== 11 || !cuitValidator(cuit)) {
      setErrors({ ...newErrors, cuitInvalido: true });
      setLoading(false);
      return;
    }

    try {
      setTextInputCustomerCUIT("Buscando en Mi Estudio...")

      const isExists = await dispatch(getAllSubsDelegationVE(cuit, null, null, null, 1, 10, false));

      if (Array.isArray(isExists) && isExists.length > 0) {
        setErrors({ ...newErrors, isExistsCUIT: true });
      } else {
        setTextInputCustomerCUIT("Buscando en ARCA...")
        const dataAFIP = await getInfoARCA(cuit);
        if (dataAFIP?.taxLegalName) {
          setFormData(prev => ({ ...prev, customerSuborganizationName: dataAFIP.taxLegalName }));
          setErrors(newErrors);
        } else {
          setErrors({ ...newErrors, isNotValidAFIP: true });
        }
      }
    } catch (error) {
      console.error("Error validando CUIT:", error);
    } finally {
      setLoading(false);
      setTextInputCustomerCUIT("Cargando...")
    }
  };

  const handleInputChange = (field) => (event) => {
    const { value } = event.target;
    let newValue = value;

    if (field === "customerSuborganizationCuit") {
      newValue = value.replace(/[^0-9]/g, "").slice(0, 11);
      setFormData(prev => ({
        ...prev,
        [field]: newValue,
        customerSuborganizationName: ""
      }));
      setErrors(prev => ({
        ...prev,
        isExistsCUIT: false,
        cuitInvalido: false,
        customerSuborganizationCuit: false,
        isNotValidAFIP: false
      }));
      return
    }

    setFormData(prev => ({ ...prev, [field]: newValue }));
    if (errors[field]) {
      setErrors(prev => {
        const newErrors = { ...prev };
        delete newErrors[field];
        return newErrors;
      });
    }
    if (field === "customerSuborganizationName" && errors.isNotValidAFIP) {
      setErrors(prev => {
        const newErrors = { ...prev, isNotValidAFIP: false };

        return newErrors;
      });
    }
  };

  const handleClose = () => {
    setFormData(initialFormState);
    setErrors({});
    onClose();
  };

  const handleSubmit = async () => {


    const validationErrors = {};
    if (!formData.customerSuborganizationCuit) validationErrors.customerSuborganizationCuit = true;
    if (!formData.customerSuborganizationName) validationErrors.customerSuborganizationName = true;
    if (!formData.accessDelegationDateTime) validationErrors.accessDelegationDateTime = true;

    if (Object.keys(validationErrors).length > 0 || Object.values(errors).some(v => v === true)) {

      setErrors(prev => ({ ...prev, ...validationErrors }));
      return;
    }

    try {
      setLoading(true);
      const body = {
        ...formData,
        accessDelegationDateTime: new Date(formData.accessDelegationDateTime).toISOString(),
        delegationAcceptationUser: decoded.idpData.email,
      };

      await dispatch(createSubsDelegationVE(body));
      if (onSubmit) onSubmit(formData);
      handleClose();
    } catch (error) {
      console.error("Error al guardar:", error);
    } finally {
      setLoading(false);
    }
  };

  if (!open) return null;

  return (
    <div className={classes.modalOverlay} onClick={(e) => e.target === e.currentTarget && handleClose()}>
      <div className={classes.modalContent}>
        <div className={classes.modalHeader}>
          <h3 className={classes.modalTitle}>Carga de CUIT aceptado en ARCA</h3>
          <button className={classes.modalCloseButton} onClick={handleClose}>×</button>
        </div>

        <div className={classes.modalBody}>
          <div className={classes.formGrid}>
            <div className={classes.formField}>
              <label className={classes.formLabel}>Fecha de aceptación <span style={{ color: "red" }}>*</span></label>
              <input
                type="date"
                value={formData.accessDelegationDateTime}
                onChange={handleInputChange("accessDelegationDateTime")}
                className={`${classes.formInput} ${errors.accessDelegationDateTime ? classes.inputError : ""}`}
              />
            </div>

            <div className={classes.formField}>
              <label className={classes.formLabel}>CUIT <span style={{ color: "red" }}>*</span></label>
              <input
                type="text"
                value={formData.customerSuborganizationCuit}
                onChange={handleInputChange("customerSuborganizationCuit")}
                onBlur={() => validateCuitFull(formData.customerSuborganizationCuit)}
                placeholder="Ingrese el CUIT"
                className={`${classes.formInput} ${errors.isExistsCUIT || errors.cuitInvalido ? classes.inputError : ""}`}
              />
              {loading && <div style={{ fontSize: '12px' }}>{textInputCustomerCUIT}</div>}

              <div style={{ minHeight: '20px' }}>
                {errors.isExistsCUIT && (
                  <div style={{ color: 'red', fontSize: '12px' }}>
                    * El CUIT ya existe. <button onClick={() => navigate(`detalleCliente/${formData.customerSuborganizationCuit}`)}>Ver CUIT</button>
                  </div>
                )}
                {errors.cuitInvalido && <div style={{ color: 'red', fontSize: '12px' }}>* CUIT inválido.</div>}
              </div>
            </div>

            <div className={classes.formField}>
              <label className={classes.formLabel}>Nombre / Razón Social <span style={{ color: "red" }}>*</span></label>
              <input
                type="text"
                value={formData.customerSuborganizationName}
                onChange={handleInputChange("customerSuborganizationName")}
                className={`${classes.formInput} ${errors.isNotValidAFIP ? classes.inputError : ""}`}
                placeholder={loading ? "Cargando..." : "Razón Social"}
                disabled={loading}
              />
              {errors.isNotValidAFIP && <div style={{ color: 'red', fontSize: '12px' }}>* No se encontró en ARCA.</div>}
            </div>

            <div className={classes.formField}>
              <label className={classes.formLabel}>Usuario</label>
              <input
                type="text"
                value={formData.delegationAcceptationUser}
                className={classes.formInput}
                disabled
                style={{ backgroundColor: '#f0f0f0' }}
              />
            </div>

            <div className={classes.formFieldFullWidth}>
              <label className={classes.formLabel}>Observaciones</label>
              <textarea
                value={formData.delegationNotes}
                onChange={handleInputChange("delegationNotes")}
                rows="3"
                className={classes.formTextarea}
                style={{ resize: "none" }}
              />
            </div>
          </div>
        </div>

        <div className={classes.modalActions}>
          <button className={classes.buttonSecondary} onClick={handleClose} disabled={loading}>
            Cancelar
          </button>
          <button
            className={classes.buttonPrimary}
            onClick={handleSubmit}
            disabled={loading || !!errors.isExistsCUIT || !!errors.cuitInvalido}
          >
            {loading ? "Procesando..." : "Guardar"}
          </button>
        </div>
      </div>
    </div>
  );
}
